import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { useRouteData } from "../RouteDataContext";
/**
 * CortevaDashboard component displays a custom dashboard for Corteva users, including navigation to KYC, Cashback, and Support.
 */
const CortevaDashboard = () => {
    const navigate = useNavigate();
    const { userData } = useRouteData()
    return (
        <>
            <div className='container  pt-6 vh-100'>
                <div className="d-none d-md-block">
                    <img
                        src={toAbsoluteUrl('/media/images/cortieva-banner.jpg')}
                        alt="Banner"
                        style={{ width: '100%', height: 'auto' }}
                        className="img-fluid rounded"
                    />
                </div>
                <div className="d-block d-md-none">
                    <img
                        src={toAbsoluteUrl('/media/images/cortieva-banner.jpg')}
                        alt="Banner"
                        style={{ width: '100%', height: 'auto' }}
                        className="img-fluid rounded"
                    />
                </div>

                <div className='d-flex justify-content-between flex-wrap mt-8'>
                    <div className='card w-100 ' style={{ border: '1px solid #E6E6E6' }}>
                        <div className="card-header px-5" style={{ minHeight: '39px' }}>
                            <div className="card-title fw-semibold fs-4 ">Menu
                            </div>
                        </div>
                        <div className='card m-4' style={{ backgroundColor: "#fefbfb", border: "1px solid #ffe7e8" }} onClick={() => navigate(`/customer/bankpancard-details/${userData?.user?.iirpl_sap_code}`)}>
                            <div className='card-body d-flex justify-content-between align-items-center'>
                                <div className='text-start'>
                                    <div className=' fw-semibolder  text-primary ' style={{ fontSize: "1.5rem" }}>KYC </div>
                                    <div className='fs-5 text-grey-700' style={{ fontSize: "1.15rem" }}>Click here to upload your Pan, Bank details</div>
                                </div>
                                <i className='fas fa-chevron-right fs-1 fw-semibolder ' style={{ color: "#6c757d" }}></i>
                            </div>
                        </div>
                        <div className='card m-4' style={{ backgroundColor: "#fefbfb", border: "1px solid #ffe7e8" }} onClick={() => navigate(`/customer/cashback/${userData?.user?.iirpl_sap_code}`)}>
                            <div className='card-body d-flex justify-content-between align-items-center'>
                                <div className='text-start'>
                                    <div className=' fw-semibolder  text-primary ' style={{ fontSize: "1.5rem" }}>Cashback </div>
                                    <div className='fs-5 text-grey-700' style={{ fontSize: "1.15rem" }}> Click here to track your cashback</div>
                                </div>
                                <i className='fas fa-chevron-right fs-1 fw-semibolder ' style={{ color: "#6c757d" }}></i>
                            </div>
                        </div>
                        <div className='card m-4' style={{ backgroundColor: "#fefbfb", border: "1px solid #ffe7e8" }} onClick={() => navigate(`/customer/support/${userData?.user?.iirpl_sap_code}`)}>
                            <div className='card-body d-flex justify-content-between align-items-center'>
                                <div className='text-start'>
                                    <div className=' fw-semibolder  text-primary ' style={{ fontSize: "1.5rem" }}>Support </div>
                                    <div className='fs-5 text-grey-700' style={{ fontSize: "1.15rem" }}> Click here to reach out to our support team </div>
                                </div>
                                <i className='fas fa-chevron-right fs-1 fw-semibolder ' style={{ color: "#6c757d" }}></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}

export default CortevaDashboard